import React from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";

import { V2 } from "../../../Api";
import { formatDateLocalNumeric, formatName } from "../../../Utilities";
import ViewToolbar from "../../ViewToolbar";
import ToolbarMenuItem from "../../ToolbarMenuItem";

import "../../../patient.css";
import "../../../list.css";


interface IPatientDocumentsInnerViewProps extends RouteComponentProps<any> {

}

interface IPatientDocumentsInnerViewState {
    isLoading: boolean | string;
    documents: any[];
}

class PatientDocumentsInnerView extends React.Component<IPatientDocumentsInnerViewProps, IPatientDocumentsInnerViewState> {
    constructor(props: Readonly<IPatientDocumentsInnerViewProps>) {
        super(props);

        const state: IPatientDocumentsInnerViewState = {
            isLoading: false,
            documents: []
        };

        this.state = state;
    }

    public componentDidMount() {
        this.loadData();
    }

    public render() {
        if (this.state.isLoading === true) {
            return <div className="patient-page-body">
                <div className="spinner spinner-center lds-dual-ring" />
            </div>;
        }
        if (typeof this.state.isLoading === "string") {
            return <div className="patient-page-body">
                <div className="error-text">{this.state.isLoading}</div>
            </div>;
        }

        return (
            <div className="patient-page-body">
                <ViewToolbar>
                    <ToolbarMenuItem right="document:edit">
                        <Link to={`/patient/${this.props.match.params.id}/documents/add`} className="icon-plus" title="Add a document..." />
                    </ToolbarMenuItem>
                </ViewToolbar>
                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th className="col-smallest">Date</th>
                            <th>Document</th>
                            <th>Created by</th>
                            <th className="col-smallest">Last updated</th>
                            <th className="col-smallest" />
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.documents.length === 0
                            ? <tr>
                                <td colSpan={10}>No documents found</td>
                            </tr>
                            : this.state.documents.map(a => <tr key={a.id} className="clickable" onClick={() => this.goDocument(a.id)}>
                                <td>{formatDateLocalNumeric(a.creationTimestamp)}</td>
                                <td>{a.name}</td>
                                <td>{formatName(a.creator.name)}</td>
                                <td>{formatDateLocalNumeric(a.modificationTimestamp)}</td>
                                <td>
                                    {a.lockedBy ? <i className="icon icon-lock" title={`Locked by ${formatName(a.lockedBy.name)}`} /> : null}
                                    {a.isFinalized ? <i className="icon icon-check" title="Finalized" /> : null}
                                    {a.hasSignatures ? <i className="icon icon-pencil" title="Signed" /> : null}
                                </td>
                            </tr>)}
                    </tbody>
                </table>
            </div>
        );
    }

    private async loadData() {
        try {
            this.setState({
                isLoading: true
            });

            const result = await V2.get<any>(`patients/${this.props.match.params.id}/documents`);

            this.setState({
                isLoading: false,
                documents: result.documents,
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || "Could not load documents"
            });
        }
    }

    private goDocument(id: string) {
        this.props.history.push(`${this.props.location.pathname}/${id}`);
    }
}

export default PatientDocumentsInnerView;
